import React from 'react'
import { View, Text } from '@react-pdf/renderer';
import moment from 'moment'

export const RelatorioChecklistOperacaoProducao = ({ dias, checklistOperacaoItem, i, styles, respostaChecklistOperacao }) => {

  const getEstoque = (estoque, unidadeProducao) => {
    let value = ''

    if (estoque != null && unidadeProducao != null) {
      if (unidadeProducao.arredondado) {
        value = Math.round(estoque).toLocaleString('pt-br')
      } else {
        value = estoque.toLocaleString('pt-br', { minimumFractionDigits: 2 })
      }

      return value + ' ' + unidadeProducao.abreviacao
    }

    return value
  }

  const getCalculoDias = (estoque, coeficiente, diasVencimento) => {
    if (estoque != null && coeficiente != null && diasVencimento != null) {
      let result = Number((coeficiente * (diasVencimento + 1)).toFixed(1))

      if (result % 1 === 0) {
        result = Math.floor(result)
      }

      return result.toLocaleString('pt-br') + " dia(s)"
    }

    return ''
  }

  function getContagem(index, codigo, data) {
    if (respostaChecklistOperacao && respostaChecklistOperacao.respostaChecklistOperacao && respostaChecklistOperacao.respostaChecklistOperacao.respostasChecklistMap[index] && respostaChecklistOperacao.respostaChecklistOperacao.respostasChecklistMap[index].length > 0) {
      const itemRespostaChecklistOperacao = respostaChecklistOperacao.respostaChecklistOperacao.respostasChecklistMap[index].find(p => moment(p.dataHora, "YYYY-MM-DD").isSame(moment(data, "YYYY-MM-DD")));
      if (itemRespostaChecklistOperacao) {
        if (itemRespostaChecklistOperacao && itemRespostaChecklistOperacao.respostasChecklistsOperacaoProducao.length > 0) {
          const item = itemRespostaChecklistOperacao.respostasChecklistsOperacaoProducao.find(p => p.idChecklistOperacaoItem == codigo);
          if (item && item.contagem) {
            return item.contagem;
          } else {
            return null;
          }
        } else {
          return null;
        }
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  function getProducao(index, codigo, data) {
    if (respostaChecklistOperacao && respostaChecklistOperacao.respostaChecklistOperacao && respostaChecklistOperacao.respostaChecklistOperacao.respostasChecklistMap[index] && respostaChecklistOperacao.respostaChecklistOperacao.respostasChecklistMap[index].length > 0) {
      const itemRespostaChecklistOperacao = respostaChecklistOperacao.respostaChecklistOperacao.respostasChecklistMap[index].find(p => moment(p.dataHora, "YYYY-MM-DD").isSame(moment(data, "YYYY-MM-DD")));
      if (itemRespostaChecklistOperacao) {
        if (itemRespostaChecklistOperacao && itemRespostaChecklistOperacao.respostasChecklistsOperacaoProducao.length > 0) {
          const item = itemRespostaChecklistOperacao.respostasChecklistsOperacaoProducao.find(p => p.idChecklistOperacaoItem == codigo);;
          if (item && item.producao) {
            return item.producao;
          } else {
            return null;
          }
        } else {
          return null;
        }
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  return (
    <View>
      <View fixed={false} key={i} style={{ marginTop: 10 }}>
        <View style={styles.row} >
          <View style={[styles.header, { width: 95, border: 0 }]}>
            <Text></Text>
          </View>
          <View style={[styles.header, { width: 40, border: 0 }]}>
            <Text></Text>
          </View>
          <View style={[styles.header, { width: 55, border: 0 }]}>
            <Text></Text>
          </View>
          <View style={[styles.header, { width: 55, border: 0 }]}>
            <Text></Text>
          </View>
          {
            (
              undefined !== dias && dias.length ?
                dias.map((dia) =>
                  <View key={dia} style={[styles.header, { width: 79.4 }]}>
                    <Text>{moment(dia).format('DD/MM/YYYY')}</Text>
                  </View>
                )
                :
                null
            )
          }
        </View>

        <View style={[styles.row, { marginTop: 0 }]} key={i} >
          <View style={[styles.header, { width: 95 }]}>
            <Text>Item</Text>
          </View>
          <View style={[styles.header, { width: 40 }]}>
            <Text>Validade (dias)</Text>
          </View>
          <View style={[styles.header, { width: 55 }]}>
            <Text>Estoque mínimo</Text>
          </View>
          <View style={[styles.header, { width: 55 }]}>
            <Text>Estoque máximo</Text>
          </View>

          {
            (
              undefined !== dias && dias.length ?
                dias.map((dia, i) =>
                  <>
                    <View>
                      <View style={{ flexDirection: 'row' }}>
                        <View style={[styles.cellSmall, { width: 38, fontFamily: 'Roboto', fontWeight: 'bold', marginHorizontal: 1 }]}>
                          <Text>Contagem</Text>
                        </View>
                        <View style={[styles.cellSmall, { width: 38, fontFamily: 'Roboto', fontWeight: 'bold', marginHorizontal: 1 }]}>
                          <Text>Quantidade</Text>
                        </View>
                      </View>
                      <View>
                        <View style={[styles.cellSmall, { width: 76, fontFamily: 'Roboto', fontWeight: 'bold', marginHorizontal: 1 }]}>
                          <Text>
                            {
                              (
                                i == 0 ? 'Seg passada' :
                                  i == 1 ? 'Ter passada' :
                                    i == 2 ? 'Qua passada' :
                                      i == 3 ? 'Qui passada' :
                                        i == 4 ? 'Sex passada' :
                                          i == 5 ? 'Sáb passado' :
                                            i == 6 ? 'Dom passado' :
                                              ''
                              )
                            }
                          </Text>
                        </View>
                      </View>
                    </View>
                  </>
                )
                :
                null
            )
          }
        </View>
      </View>

      {
        (checklistOperacaoItem[i] !== undefined && checklistOperacaoItem[i].checklistsOperacaoItens !== undefined && checklistOperacaoItem[i].checklistsOperacaoItens.length > 0 && undefined !== dias && dias.length) ?
          checklistOperacaoItem[i].checklistsOperacaoItens.map((n, index) => {
            return (
              <View wrap={false} style={{ 'backgroundColor': (index % 2 == 0 ? '#E8E8E8' : '#FFFFFF') }}>
                <View style={styles.rowTop} key={n.id}>
                  <View style={[styles.cell, { width: 95 }]}>
                    <Text>{n.descricao}</Text>
                  </View>
                  {
                    n.totvsInsumo?.contabilizado ?
                      <>
                        <View style={[styles.cell, { width: 40 }]}>
                          <Text>{(n.diasVencimento != null ? n.diasVencimento : '')}</Text>
                        </View>
                        <View style={[styles.cell, { width: 55 }]}>
                          <Text>{getEstoque(n.estoqueMinimo, n.unidadeProducao)}</Text>
                        </View>
                        <View style={[styles.cell, { width: 55 }]}>
                          <Text>{getEstoque(n.estoqueMaximo, n.unidadeProducao)}</Text>
                        </View>
                      </>
                      :
                      <View style={[styles.cell, { width: 150 }]}>
                        <Text>NÃO CONTABILIZADO</Text>
                      </View>
                  }

                  {
                    dias.map((dia, i) =>
                      <>
                        <View style={[styles.cellSpace, { borderRight: dias.length - 1 != i ? 1 : 0 }]}>
                          <View style={[styles.cellSmall, { width: 35, borderBottom: 1, marginHorizontal: 1 }]}>
                            <Text>{getContagem(n.idChecklistOperacao, n.id, dia)}</Text>
                          </View>
                          <View style={[styles.cellSmall, { width: 35, borderBottom: 1, marginHorizontal: 1 }]}>
                            <Text>{getProducao(n.idChecklistOperacao, n.id, dia)}</Text>
                          </View>
                        </View>
                      </>
                    )
                  }

                </View>

                <View style={styles.rowBottom} key={n.idChecklistOperacao + '_' + n.id}>
                  <View style={[styles.cell, { width: 95 }]}>
                    <Text></Text>
                  </View>
                  {
                    n.totvsInsumo?.contabilizado ?
                      <>
                        <View style={[styles.cell, { width: 40 }]}>
                          <Text></Text>
                        </View>
                        <View style={[styles.cell, { width: 55 }]}>
                          <Text>{getCalculoDias(n.estoqueMinimo, n.coeficienteEstoqueMinimo, n.diasVencimento)}</Text>
                        </View>
                        <View style={[styles.cell, { width: 55 }]}>
                          <Text>{getCalculoDias(n.estoqueMaximo, n.coeficienteEstoqueMaximo, n.diasVencimento)}</Text>
                        </View>
                      </>
                      :
                      <View style={[styles.cell, { width: 150 }]}>
                        <Text></Text>
                      </View>
                  }
                  <View style={[styles.cellSmall2, { width: 77, borderRight: 1 }]}>
                    <Text style={{ fontSize: 7 }} >
                      {
                        (n.vendaUltimaSegunda != null ?
                          n.vendaUltimaSegunda.toLocaleString('pt-br', { minimumFractionDigits: 2 })
                          :
                          ''
                        )
                      }
                    </Text>
                  </View>
                  <View style={[styles.cellSmall2, { width: 77, borderRight: 1 }]}>
                    <Text style={{ fontSize: 7 }} >
                      {
                        (n.vendaUltimaTerca != null ?
                          n.vendaUltimaTerca.toLocaleString('pt-br', { minimumFractionDigits: 2 })
                          :
                          ''
                        )
                      }
                    </Text>
                  </View>
                  <View style={[styles.cellSmall2, { width: 77, borderRight: 1 }]}>
                    <Text style={{ fontSize: 7 }} >
                      {
                        (n.vendaUltimaQuarta != null ?
                          n.vendaUltimaQuarta.toLocaleString('pt-br', { minimumFractionDigits: 2 })
                          :
                          ''
                        )
                      }
                    </Text>
                  </View>
                  <View style={[styles.cellSmall2, { width: 77, borderRight: 1 }]}>
                    <Text style={{ fontSize: 7 }} >
                      {
                        (n.vendaUltimaQuinta != null ?
                          n.vendaUltimaQuinta.toLocaleString('pt-br', { minimumFractionDigits: 2 })
                          :
                          ''
                        )
                      }
                    </Text>
                  </View>
                  <View style={[styles.cellSmall2, { width: 77, borderRight: 1 }]}>
                    <Text style={{ fontSize: 7 }} >
                      {
                        (n.vendaUltimaSexta != null ?
                          n.vendaUltimaSexta.toLocaleString('pt-br', { minimumFractionDigits: 2 })
                          :
                          ''
                        )
                      }
                    </Text>
                  </View>

                  <View style={[styles.cellSmall2, { width: 77, borderRight: 1 }]}>
                    <Text style={{ fontSize: 7 }} >
                      {
                        (n.vendaUltimoSabado != null ?
                          n.vendaUltimoSabado.toLocaleString('pt-br', { minimumFractionDigits: 2 })
                          :
                          ''
                        )
                      }
                    </Text>
                  </View>
                  <View style={[styles.cellSmall2, { width: 77 }]}>
                    <Text style={{ fontSize: 7 }} >
                      {
                        (n.vendaUltimoDomingo != null ?
                          n.vendaUltimoDomingo.toLocaleString('pt-br', { minimumFractionDigits: 2 })
                          :
                          ''
                        )
                      }
                    </Text>
                  </View>

                </View>
              </View>
            );
          })
          : null
      }

    </View>

  );
};
